import QRCode from "react-qr-code";
import { DEMO_QR_VALUE, DEMO_SERIAL } from "../../config/site";

const SIZES = {
  xs: "w-[92px] p-2 gap-1.5 text-[7px]",
  sm: "w-[132px] p-3 gap-2 text-[9px]",
  md: "w-[200px] p-4 gap-3 text-[11px]",
  lg: "w-[260px] p-5 gap-4 text-[13px]",
};

export const CarlinkSticker = ({ size = "md", serial = DEMO_SERIAL, value = DEMO_QR_VALUE, className = "", testId }) => (
  <figure
    data-testid={testId}
    aria-label={`CARLINK sticker with QR code, ID ${serial}`}
    className={`sticker flex flex-col items-center rounded-[14%/10%] ${SIZES[size]} ${className}`}
  >
    <div className="flex w-full items-center justify-center gap-1.5">
      <span className="h-[0.55em] w-[0.55em] rounded-full bg-[#FF5500]" />
      <span className="font-display font-extrabold tracking-[0.32em] text-slate-50" style={{ fontSize: "1.25em" }}>
        CARLINK
      </span>
    </div>
    <div className="w-full rounded-[10%] bg-white p-[7%]">
      <QRCode value={value} level="M" bgColor="#FFFFFF" fgColor="#07080C" style={{ width: "100%", height: "auto" }} />
    </div>
    <figcaption className="flex flex-col items-center leading-tight">
      <span className="font-mono font-semibold tracking-[0.28em] text-slate-200">SCAN TO CONTACT</span>
      <span className="mt-[0.35em] font-mono font-bold tracking-[0.18em] text-[#FF5500]">{serial}</span>
    </figcaption>
  </figure>
);
